import { formatDateLong } from 'platform/utilities/date';
import PropTypes from 'prop-types';
import React from 'react';
import content from '../../locales/en/content.json';

const ConfirmationPrintView = ({ submissionName, timestamp }) => (
  <>
    <img
      src="/img/design/logo/logo-black-and-white.png"
      className="vads-u-max-width--100 vads-u-margin-bottom--4"
      width="300"
      alt=""
    />

    <h1 className="vads-u-font-size--h2 vads-u-margin-bottom--0">
      {content['form-title']}
    </h1>
    <div>{content['form-subtitle']}</div>

    <h2 className="vads-u-font-size--h3">
      You submitted your application for health benefits
    </h2>

    <hr className="vads-u-margin-y--4" />

    <h3 className="vads-u-margin-top--0">Your submission information</h3>
    <h4>Who submitted this form</h4>
    <p className="dd-privacy-mask" data-dd-action-name="submission name">
      {submissionName}
    </p>

    {timestamp ? (
      <>
        <h4>Date submitted</h4>
        <p
          className="dd-privacy-mask vads-u-margin-bottom--0"
          data-dd-action-name="submission date"
        >
          {formatDateLong(timestamp)}
        </p>
      </>
    ) : null}

    <hr className="vads-u-margin-top--4 vads-u-margin-bottom--0" />
  </>
);

ConfirmationPrintView.propTypes = {
  submissionName: PropTypes.string,
  timestamp: PropTypes.number,
};

export default ConfirmationPrintView;
